import { render, staticRenderFns } from "./TemplateSetup.vue?vue&type=template&id=712c7c4e&scoped=true"
import script from "./TemplateSetup.vue?vue&type=script&lang=js"
export * from "./TemplateSetup.vue?vue&type=script&lang=js"
import style0 from "./TemplateSetup.vue?vue&type=style&index=0&id=712c7c4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c7c4e",
  null
  
)

export default component.exports